const messages = {
  en: {
    title: "Oil Fleet Monitoring System",
    subtitle: "The Excise Department of Thailand",
    name: "PDSS",
    home: "Home",
    dashboard: "Dashboard",
    report: "Report",
    notification: "Notification",
    users: "Users",
    oilPriceLog: "Oil Price Log",
    addOilPrice: "Add Oil price",
    menu1: "menu one",
    menu2: "menu two",
    destinationType: "Destination type",
    search: "Search",
    download: "Download",
    greenDiesel: "Green diesel",
    domesticOil: "Domestic oil",
    exportOil: "Export oil",
    totalOil:"Total oil",
    TotalIsExciseRate: "Total excise rate",
    TotalIsExciseExemption: "Total excise exemption",
    OilPrice: "Oil price",
    PercentOfLost: "1% of lost case",
    RefineryIRPC: "Refinery IRPC",
    RefinerySPRC: "Refinery SPRC",
    RefineryTOP: "Refinery TOP",
    RefineryBCP: "Refinery BCP",
    RefineryPTTGC: "Refinery PTTGC",
    RefineryESSO: "Refinery ESSO",
    Liter: "L",
    Baht: "฿",
    Graphics: "Graphics",
    No: "No.",
    RadarChart: "RadarChart",
    SunBurstChart: "SunBurstChart",
    StackedColumnChart: "StackedColumnChart",
    OilTypeStackedColumnChart: "OilTypeStackedColumnChart",
    LineChart: "LineChart",
    ShipmentTable:{
      Shipment: "Shipment",
      Id: "ID",
      MemberCode: "Member code",
      RegisterNumber: "Register number",
      TankerName: "Tanker name",
      VesselName: "Vessel name",
      TransferVolume: "Transfer Volume",
      TransferStart: "Transfer Start"
    },
    TankerTable:{
      Id: "ID",
      MMSI: "MMSI",
      TankerName: "Tanker name",
      TransferVolume: "Transfer Volume",
      TransferTotalVolume: "Transfer Total Volume",
      Capacity: "Capacity",
      TransferStart: "Transfer Start",
      OilType: "Oil Type"
    },
    RefineryTable:{
      Id: "ID",
      RefineryName: "Refinery Name",
      TankerName: "Tanker name",
      TransferVolume: "Transfer Volume",
      TransferStart: "Transfer Start",
      Detail:"Detail",
      ReadAt: "Read At"
    },
    message: {
      hello: "hello world",
    },
    profile: "Profile",
    editProfile: "แก้ไขข้อมูลส่วนตัว",
    information: "Information",
    profilePage: {
      joined: "Joined",
      lives: "Lives",
      email: "Email",
      website: "Website",
      username: "Username",
      firstName: "First Name",
      lastName: "Last Name",
      dateOfBirth: "Date of Birth",
      address: "Address",
      city: "City",
      country: "Country",
      password: "Password",
      changePassword: "Change Password",
      changePasswordMessage: "Change your password or recover your current one.",
      currentPassword: "Current Password",
      newPassword: "New Password",
      confirmPassword: "Confirm Password",
      nickName: "Nickname",
      telephone: "Telephone",
      gender: "Gender",
      male: "Male",
      female: "Female",
    },
    addUser: "Add User",
    editUser: "Edit User",
    input: "Input"
  },
  th: {
    title: "ระบบตรวจสอบเฝ้าระวังการจำหน่ายน้ำมัน",
    subtitle: "สำหรับชาวประมงในเขตต่อเนื่องของราชอาณาจักร",
    name: "PDSS",
    home: "หน้าหลัก",
    dashboard: "แดชบอร์ด",
    report: "รายงาน",
    notification: "การเเจ้งเตือน",
    users: "ผู้ใช้งาน",
    oilPriceLog: "ราคาน้ำมัน",
    addOilPrice: "เพิ่มราคาน้ำมัน",
    menu1: "เมนู 1",
    menu2: "เมนู 2",
    destinationType: "ปลายทาง",
    search: "ค้นหา",
    download: "ดาวน์โหลด",
    message: {
      hello: "สวัดดี",
    },
    greenDiesel: "น้ำมันเขียว",
    domesticOil: "น้ำมันในประเทศ",
    exportOil: "น้ำมันส่งออกนอกประเทศ",
    totalOil:"ยอดรวมน้ำมัน",
    TotalIsExciseRate: "มูลค่าน้ำมัน",
    TotalIsExciseExemption: "มูลค่าที่ขอยกเว้น/คืนภาษี",
    OilPrice: "ราคาน้ำมัน/ลิตร ",
    PercentOfLost: "มูลค่า 1% กรณีสูญหาย",
    RefineryIRPC: "โรงกลั่น IRPC",
    RefinerySPRC: "โรงกลั่น SPRC",
    RefineryTOP: "โรงกลั่น TOP",
    RefineryBCP: "โรงกลั่น BCP",
    RefineryPTTGC: "โรงกลั่น PTTGC",
    RefineryESSO: "โรงกลั่น ESSO",
    Liter: "ล.",
    Baht: "บ.",
    Graphics: "กราฟิกแสดงผล",
    No: "แบบที่",
    RadarChart: "กราฟวงกลม",
    SunBurstChart: "กราฟดวงอาทิตย์",
    StackedColumnChart: "แผนภูมิยอดรวมน้ำมัน",
    OilTypeStackedColumnChart: "แผนภูมิประเภทน้ำมัน",
    LineChart: "กราฟเส้น",
    ShipmentTable:{
      Shipment: "ตารางการจัดส่งน้ำมัน",
      Id: "ลำดับ",
      MemberCode: "รหัสสมาชิก",
      RegisterNumber: "ทะเบียนเรือ",
      TankerName: "สถานีบริการน้ำมัน",
      VesselName: "เรือประมง",
      TransferVolume: "ปริมาณการจำหน่ายน้ำมัน",
      TransferStart: "วันที่/เวลาเริ่ม"
    },
    TankerTable:{
      Id: "ลำดับ",
      MMSI: "MMSI",
      TankerName: "ชื่อเรือบรรทุกน้ำมัน",
      TransferVolume: "ปริมาณน้ำมัน",
      TransferTotalVolume: "ปริมาณน้ำมันรวม",
      Capacity: "ความจุถังน้ำมัน",
      TransferStart: "วันที่เริ่ม",
      OilType: "ประเภทน้ำมัน"
    },
    RefineryTable:{
      Id: "ID",
      RefineryName: "โรงกลั่น",
      TankerName: "ชื่อเรือบรรทุกน้ำมัน",
      TransferVolume: "ปริมาณน้ำมัน",
      TransferStart: "วันที่เริ่ม",
      Detail:"รายละเอียด",
      ReadAt: "อ่านเมื่อ"

    },
    profile: "ข้อมูลส่วนตัว",
    editProfile: "แก้ไขข้อมูลส่วนตัว",
    information: "ข้อมูล",
    profilePage: {
      joined: "เข้าร่วม",
      lives: "อาศัย",
      email: "อีเมล",
      website: "เว็บไซต์",
      username: "ชื่อผู้ใช้",
      firstName: "ชื่อ",
      lastName: "นามสกุล",
      dateOfBirth: "วันเดือนปีเกิด",
      address: "ที่อยู่",
      city: "เมือง",
      country: "ประเทศ",
      password: "รหัสผ่าน",
      changePassword: "เปลี่ยนรหัสผ่าน",
      changePasswordMessage: "เปลี่ยนรหัสผ่านหรือกู้คืนรหัสผ่านปัจจุบันของคุณ",
      currentPassword: "รหัสผ่านปัจจุบัน",
      newPassword: "รหัสผ่านใหม่",
      confirmPassword: "ยื่นยันรหัสผ่าน",
      nickName: "ชื่อเล่น",
      telephone: "โทรศัพท์",
      gender: "เพศ",
      male: "ชาย",
      female: "หญิง",
    },
    addUser: "เพิ่มผู้ใช้งาน",
    editUser: "แก้ไขข้อมูลผู้ใช้งาน",
    input: "นำเข้า"
  },
};

export default messages;
